/**
 * zod configured with translated default messages, so schemas can stay terse
 * (`z.string().min(1)`) and still produce localized inline errors.
 * For a field-specific message use a lazy error: `{ error: () => i18n.t("…") }`.
 */
import { z } from "zod"
import i18n from "@/i18n"

z.config({
  customError: (issue) => {
    switch (issue.code) {
      case "too_small":
        if (issue.origin === "string")
          return Number(issue.minimum) <= 1
            ? i18n.t("validation.required")
            : i18n.t("validation.minLength", { count: Number(issue.minimum) })
        if (issue.origin === "number" || issue.origin === "int")
          return i18n.t("validation.min", { min: Number(issue.minimum) })
        if (issue.origin === "array") return i18n.t("validation.minItems", { count: Number(issue.minimum) })
        return undefined
      case "too_big":
        if (issue.origin === "string") return i18n.t("validation.maxLength", { count: Number(issue.maximum) })
        if (issue.origin === "number" || issue.origin === "int")
          return i18n.t("validation.max", { max: Number(issue.maximum) })
        return undefined
      case "invalid_format":
        if (issue.format === "email") return i18n.t("validation.email")
        if (issue.format === "url") return i18n.t("validation.url")
        return i18n.t("validation.format")
      case "invalid_type":
        if (issue.expected === "number") return i18n.t("validation.number")
        return i18n.t("validation.required")
      default:
        return undefined
    }
  },
})

export { z }
